// deps
// eslint-disable-next-line import/no-unresolved
import Router from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router";
// eslint-disable-next-line import/no-unresolved
import Uri from "@splitfire-agency/raiden-library/dist/libraries/Uri";

const cdnRouter = new Router(
  // @ts-ignore
  new Uri(
    process.env.NEXT_PUBLIC_LEGACY_PUBLIC_CDN_SCHEME,
    undefined,
    process.env.NEXT_PUBLIC_LEGACY_PUBLIC_CDN_HOSTNAME,
    undefined,
  ),
);

cdnRouter.group("", (cdnRouter) => {
  cdnRouter.get("").setId("@cdn");
  cdnRouter.get(":path").setConstraint("path", /.*/).setId("@cdn/assets");
  cdnRouter.get(":path").setConstraint("path", /.*/).setId("@cdn/public");
  cdnRouter.group("/document", (cdnRouter) => {
    cdnRouter.get("/EtatPreparatoire.pdf").setId("@cdn/etat-preparatoire");
    cdnRouter.get("/Coupe1.pdf").setId("@cdn/coupe-1");
    cdnRouter.get("/Coupe2.pdf").setId("@cdn/coupe-2");
    cdnRouter.get("/Plan1.pdf").setId("@cdn/plan-1");
    cdnRouter.get("/Plan2.2.pdf").setId("@cdn/plan-2-2");
  });
  cdnRouter.group("/mp3", (cdnRouter) => {
    cdnRouter.get("/-3.mp3").setId("@cdn/mp3-short");
    cdnRouter.get("/-4.mp3").setId("@cdn/mp3-long");
  });
});

export default cdnRouter;
